export const messageTypes = {
    error: "error"
};

export interface ErrorOccurred {
    errorMessage: string;
    status?: number;
    id: string;
}
